// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLayout_root__3MPlG","content":"MainLayout_content__2Ors0"};